"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.MachineSelectorButtons = exports.MachineSelector = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importStar(require("react"));
const style_1 = require("./style");
const Layout_1 = require("../Layout");
const TreeView_1 = require("../TreeView");
const Primitives_1 = require("../Primitives");
const Highlight_1 = require("../Highlight");
const react_i18next_1 = require("react-i18next");
const __1 = require("..");
const MachineSelector = ({ locations, unassignedLocationId, machines, selectedMachines, deSelectedMachines, machineClicked, selectedMachinesClicked, multipleMachinesClicked, renderIcon, machineTooltip, configuredMachines, notConfiguredMachineToolTip, unconfiguredMachines, unconfiguredMachinesToolTip, }) => {
    const { t } = (0, react_i18next_1.useTranslation)("central-web-app-components");
    const [filteredMachineName, setFilteredMachine] = (0, react_1.useState)("");
    const [openLocations, setOpenLocations] = (0, react_1.useState)([]);
    // Everytime the selectedMachine changes open the locations to reveal it.
    react_1.default.useEffect(() => {
        if (!selectedMachines)
            return;
        const machine = machines.find(({ id }) => selectedMachines.includes(id));
        if (!machine)
            return;
        const location = locations.find(({ id }) => id === (machine === null || machine === void 0 ? void 0 : machine.locationId));
        if (!location)
            return;
        setOpenLocations((x) => [...x, location.id]);
        location.ancestors.forEach((id) => void setOpenLocations((x) => [...x, id]));
    }, [machines, locations, setOpenLocations, selectedMachines]);
    const filteredMachines = react_1.default.useMemo(() => filteredMachineName
        ? machines.filter((machine) => machine.name
            .toLowerCase()
            .includes(filteredMachineName.toLowerCase()))
        : machines, [filteredMachineName, machines]);
    const renderLocationNode = react_1.default.useCallback((location) => {
        const isUnassigned = location.id === unassignedLocationId;
        return (react_1.default.createElement(style_1.NodeWrapper, { tabIndex: 0, noPointer: isUnassigned, onClick: (event) => {
                if (event.detail === 2)
                    setOpenLocations((x) => x.includes(location.id)
                        ? x.filter((x) => x !== location.id)
                        : [...x, location.id]);
            } },
            react_1.default.createElement(Layout_1.Flex, { width: "100%", justify: "space-between", align: "center", key: location.id },
                react_1.default.createElement(Layout_1.Flex, { align: "center", justify: "flex-start" },
                    react_1.default.createElement(Layout_1.Flex, { align: "center", justify: "flex-start", noGrow: true, noOverflow: true, noResize: true, noWrap: true, width: "80%" },
                        react_1.default.createElement(__1.Text, { style: {
                                flexGrow: 1,
                                width: 0,
                            } }, location.name))))));
    }, [unassignedLocationId]);
    const renderMachineNode = react_1.default.useCallback((machine) => {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(style_1.NodeWrapper, { "aria-label": "machine selector machine node", onClick: (event) => {
                    (unconfiguredMachines === null || unconfiguredMachines === void 0 ? void 0 : unconfiguredMachines.length) &&
                        unconfiguredMachines.includes(machine.id)
                        ? null
                        : configuredMachines !== undefined &&
                            !configuredMachines.includes(machine.id)
                            ? null
                            : !(deSelectedMachines === null || deSelectedMachines === void 0 ? void 0 : deSelectedMachines.includes(machine.id))
                                ? event.ctrlKey && selectedMachinesClicked
                                    ? selectedMachinesClicked(machine.id, event)
                                    : event.shiftKey && multipleMachinesClicked
                                        ? multipleMachinesClicked(machine.id, event)
                                        : event
                                            ? machineClicked(machine.id, event)
                                            : null
                                : null;
                }, selected: selectedMachines === null || selectedMachines === void 0 ? void 0 : selectedMachines.includes(machine.id), deSelected: (deSelectedMachines === null || deSelectedMachines === void 0 ? void 0 : deSelectedMachines.includes(machine.id)) ||
                    (configuredMachines !== undefined &&
                        !configuredMachines.includes(machine.id)), tabIndex: 0, title: (unconfiguredMachines === null || unconfiguredMachines === void 0 ? void 0 : unconfiguredMachines.length) &&
                    unconfiguredMachines.includes(machine.id)
                    ? unconfiguredMachinesToolTip
                    : configuredMachines !== undefined &&
                        !configuredMachines.includes(machine.id)
                        ? notConfiguredMachineToolTip
                        : machineTooltip === null || machineTooltip === void 0 ? void 0 : machineTooltip(machine.id) },
                react_1.default.createElement(style_1.SelectedBar, { selected: selectedMachines === null || selectedMachines === void 0 ? void 0 : selectedMachines.includes(machine.id) }),
                react_1.default.createElement(Layout_1.Flex, { width: "100%", justify: "space-between", align: "center", key: machine.id },
                    react_1.default.createElement(Layout_1.Flex, { align: "center", justify: "flex-start", noResize: true, noWrap: true, noOverflow: true, width: "80%" },
                        renderIcon(machine),
                        react_1.default.createElement(Layout_1.FlexSpace, null),
                        filteredMachineName ? (react_1.default.createElement(Highlight_1.Highlight, { substring: filteredMachineName, word: machine.name })) : (react_1.default.createElement(__1.TooltipOnOverflow, { style: {
                                flexGrow: 1,
                                width: 0,
                            } }, machine.name)))))));
    }, [
        selectedMachines,
        deSelectedMachines,
        machineTooltip,
        renderIcon,
        filteredMachineName,
        selectedMachinesClicked,
        multipleMachinesClicked,
        machineClicked,
        configuredMachines,
        notConfiguredMachineToolTip,
        unconfiguredMachines,
        unconfiguredMachinesToolTip,
    ]);
    const getLocationChildren = (id) => {
        const location = locations.find((location) => location.id === id);
        if (!location)
            return [];
        if (!id) {
            return filteredMachines.filter((machine) => !machine.locationId);
        }
        else {
            return [
                ...filteredMachines.filter((machine) => machine.locationId === id),
                ...location.children
                    .filter((id) => getLocationChildren(id).length)
                    .map((id) => ({ id })),
            ];
        }
    };
    return (react_1.default.createElement(style_1.Wrapper, null,
        react_1.default.createElement(__1.MagnifyingGlass, null),
        react_1.default.createElement(Primitives_1.Input, { placeholder: t `placeholder-machineName`, value: filteredMachineName, onChange: (e) => setFilteredMachine(e.target.value), clearButton: true, magnifyingGlass: true }),
        filteredMachineName && (react_1.default.createElement(Primitives_1.ClearButton, { onClick: () => setFilteredMachine("") })),
        react_1.default.createElement(Layout_1.FlexSpace, null),
        react_1.default.createElement(style_1.Container, null, [locations.find((l) => l.id === "")]
            .concat(locations.filter((l) => !!l.id))
            .filter((l) => l && !l.parentId)
            .map((location) => location && (react_1.default.createElement(TreeView_1.TreeViewWithoutDrag, { key: location.id, id: location.id, render: ({ id }) => {
                const location = locations.find((location) => location.id === id);
                if (location && getLocationChildren(location.id).length)
                    return renderLocationNode(location);
                const machine = machines.find((machine) => machine.id === id);
                if (machine)
                    return renderMachineNode(machine);
                return undefined;
            }, getChildren: getLocationChildren, isOpen: (id) => openLocations.includes(id), onClick: (id) => setOpenLocations((x) => x.includes(id) ? x.filter((x) => x !== id) : [...x, id]) }))))));
};
exports.MachineSelector = MachineSelector;
/** Separate buttons  */
const MachineSelectorButtons = ({ selectButtonDisabled, cancelButtonDisabled, onSelect, onCancel }) => {
    const { t } = (0, react_i18next_1.useTranslation)("central-web-app-components");
    return (react_1.default.createElement(Layout_1.Flex, { style: {
            alignSelf: "center",
            justifyContent: "end",
            gap: 6,
        } },
        react_1.default.createElement(Primitives_1.Button, { "aria-label": "machine selector select button", disabled: selectButtonDisabled, onClick: onSelect }, t `button-OK`),
        react_1.default.createElement(Primitives_1.Button, { "aria-label": "machine selector cancel button", disabled: cancelButtonDisabled, onClick: onCancel }, t `button-Cancel`)));
};
exports.MachineSelectorButtons = MachineSelectorButtons;
//# sourceMappingURL=index.js.map